import React, {useState, useContext, useEffect} from "react";
import {RealmContext, TokenContext, TreeContext} from "../../Store";

import Slide from "@mui/material/Slide";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";

import DataComponentService from "../../../services/DataComponentService";

import {trackPromise} from "react-promise-tracker";

import {Form, Formik} from "formik";

import UploadService from "../../../services/upload-files.service";
import UploadDialog from "./UploadDialog";
import {confirmWrapper} from "../../../shared/confirm";
import TreeComponentTypeService from "../../../services/TreeComponentTypeService";

import styled from 'styled-components';
import DataobjectService from "../../../services/DataobjectService";
import AttachmentList from '../../../shared/AttachmentList';
import DataComponentButtonToolbar from '../Datacomponents/DataComponentButtonToolbar';
import DataComponentList from "../Datacomponents/DataComponentList";

import {useStylesDialog} from "../../../shared/useStyleDialog";
import UserService from "../../../services/UserService";
import ComponentFormAppBar from "../Datacomponents/ComponentFormAppBar";


const initialValues = {
    name: '',
    number: '',
    label: '',
    description: '',
    componentAttributeList: [],
    guid: '',
    id: null,
    position: '',
    deactivated: 0,
    geom: ''
}

const Label = styled.label`
  left: 26px;
  pointer-events: none;
  position: absolute;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  z-index: 1;
  background-color: #ffffff;
  color: #888888;
  padding-left: 4px;
  padding-right: 4px;
  top: ${(props) => (props.isFloating ? `-2px` : `35%`)};
  font-size: ${(props) => (props.isFloating ? `0.75rem` : `1rem`)};
`;

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

function ComponentFormView({dataObjectSelected, setDataComponentFormDialogOpen, DataComponentFormDialogOpen, componentSelected, componentType, attributeList, setAttributeList, realestateobjectGuid, handleActivateClick, handleDeactivateClick, saveObject, reloadComponentList, userProject}) {
    const classesDialog = useStylesDialog();

    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);
    const [formValues, setFormValues] = useState(null);

    const [myComponentType, setMyComponentType] = useState({});

    const tree = useContext(TreeContext);
    const treeItemsState = tree.items;
    const setTreeItemsState = tree.setItems;
    const [value, setValue] = React.useState(null);
    const [parentComponentValue, setParentComponentValue] = React.useState(null);

    const [fileInfos, setFileInfos] = useState([]);

    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

    const [newRealestateobjectGuid, setNewRealestateobjectGuid] = useState(null);
    const [realestateobjectSubValue, setRealestateobjectSubValue] = useState(null);

    const [componentFlatListValues, setComponentFlatListValues] = useState([]);
    let myAttributList = componentType?.attribute;
    let attributes = componentSelected.componentAttributeList;

    const componentFlatList = [];
    useEffect(() => {
        if(!UserService.isLoggedIn()) {
            UserService.doLogout();
        }
    }, [])

    useEffect(() => {
        if(realestateobjectGuid) {
            setNewRealestateobjectGuid(realestateobjectGuid);
        } else {
            setNewRealestateobjectGuid(componentSelected.realestateobjectGuid);
        }

        if ((!treeItemsState || treeItemsState.length === 0) && (token && token !== 'Kein Token generiert!')) {
            TreeComponentTypeService.getTreeData(token, realm)
                .then((res) => {
                    setTreeItemsState(res.data);
                })
        }

        if(componentSelected &&  componentSelected.id) {
            const savedValues = {
                name: componentSelected.name,
                number: componentSelected.number ? componentSelected.number : '',
                label: componentSelected.label ? componentSelected.label : '',
                description: componentSelected.description ? componentSelected.description : '',
                guid: componentSelected.guid,
                id: componentSelected.id,
                deactivated: componentSelected.deactivated,
                position: componentSelected.position ? componentSelected.position : '',
                geom: componentSelected.geom ? componentSelected.geom : ''
            }
            if(componentSelected.parentComponent) {
                const myParentComponent = {};
                myParentComponent.name = componentSelected.parentComponent;
                myParentComponent.id = componentSelected.parentComponentId;
                myParentComponent.guid = componentSelected.parentComponentGuid;
                myParentComponent.title = componentSelected.parentComponent + ' - ' + componentSelected.realestateobjectName;
                setParentComponentValue(myParentComponent);
            } else {
                setParentComponentValue(null);
            }

            if(myAttributList) {
                myAttributList.forEach((item) => {
                    savedValues['attr_' + item.attribute_id] = item.value ? item.value : '';
                })
            }

            if(componentSelected.componentAttributeList) {
                componentSelected.componentAttributeList.forEach((item) => {
                    if(item.mmsAttributeId) {
                        const attrType = myAttributList?.find(
                            a => a.attribute_id?.toString() === item.mmsAttributeId?.toString()
                        );
                        if (attrType?.data_type === 'Boolean') {
                            savedValues['attr_' + item.mmsAttributeId] =
                                item.value === 'true' || item.value === true || item.value === 1 || item.value === '1';
                        } else {
                            savedValues['attr_' + item.mmsAttributeId] = item.value;
                        }
                    } else {
                        savedValues['attribute_tenant_' + item.id] = item.value ? item.value : "";
                    }
                });

                if(!dataObjectSelected || (dataObjectSelected instanceof Array && dataObjectSelected.length === 0)) {
                    DataobjectService.getRealestateObject(token, realm, componentSelected.realestateobjectGuid)
                        .then(result => {
                            const item = result.data
                            setRealestateobjectsValues(item)
                            const myItem = {};
                            myItem.name = item.name;
                            myItem.id = item.id;
                            myItem.guid = item.guid;
                            myItem.title = item.number + ' - ' + item.name;
                            myItem.key = item.guid;
                            setRealestateobjectSubValue(myItem);
                        });
                }
                DataComponentService.getAllComponentsToRealestateobject(token, realm, componentSelected.realestateobjectGuid)
                    .then(async(result) => {
                        await setRealestateComponents(result.data);
                        setComponentFlatListValues(componentFlatList)
                    });
            }

            const myTempComponentType = {};
            myTempComponentType.objecttypeId = componentType.objecttype_id;
            myTempComponentType.name = componentType.name;
            myTempComponentType.mmsCode = componentType.code;
            myTempComponentType.mmsCafmId = componentType.global_id;
            myTempComponentType.mmsGlobalId = componentType.global_id;
            setMyComponentType(myTempComponentType);

            setFormValues(savedValues);
            if(componentSelected.componentAttachmentList?.length > 0) {
                setFileInfos(componentSelected.componentAttachmentList)
            } else {
                setFileInfos([]);
            }
        } else {
            setFormValues(null);
            if(componentType?.length == 0) {
                if (!treeItemsState || treeItemsState.length === 0) {
                    TreeComponentTypeService.getTreeData(token, realm)
                        .then((res) => {
                            setTreeItemsState(res.data);
                        })
                }
            }
            setFileInfos([]);
            if((dataObjectSelected.realestateobjectType || dataObjectSelected.realestateobjectTypeGuid) && dataObjectSelected.guid) {
                DataComponentService.getComponentsToRealestateobject(token, realm, dataObjectSelected.guid)
                    .then(async (result) => {
                        await setRealestateComponents(result.data);
                        setComponentFlatListValues(componentFlatList)
                    });
            }
        }
        if((dataObjectSelected && dataObjectSelected.guid) && !componentSelected?.realestateobjectGuid) {
            const item = dataObjectSelected;
            setRealestateobjectsValues(item).then(()=> {
                const myItem = {};
                myItem.name = item.name;
                myItem.id = item.id;
                myItem.guid = item.guid;
                myItem.title = item.number + ' - ' + item.name;
                myItem.key = item.guid;
                setRealestateobjectSubValue(myItem);
            })
        } else if(componentSelected?.realestateobjectGuid){
            DataobjectService.getRealestateObject(token, realm, componentSelected.realestateobjectGuid)
                .then(result => {
                    const item = result.data
                    const myItem = {};
                    myItem.name = item.name;
                    myItem.id = item.id;
                    myItem.guid = item.guid;
                    myItem.title = item.number + ' - ' + item.name;
                    myItem.key = item.guid;
                    setRealestateobjectSubValue(myItem);
                });
        }

    }, [componentSelected, componentType, attributeList, realm, token, treeItemsState, setTreeItemsState, setNewRealestateobjectGuid, realestateobjectGuid]);


    // Autocomplete-Liegenschaftlist
    const [liegenschaftSubFlatList, setLiegenschaftSubFlatList] = useState([]);
    const lsfl = [];


    function convert3(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.id;
        myItem.guid = item.guid;
        myItem.title = item.number + ' - ' + item.name;
        myItem.key = item.guid;
        lsfl.push(myItem);
    }

    const setRealestateobjectsValues = async(val) => {
        if (val && val.guid) {
            const objsParents = await DataobjectService.listrealestateobjectparents(token, realm, val.guid);
            const objsSiblings = await DataobjectService.listrealestateobjectsiblings(token, realm, val.guid);
            const objsChildren = await DataobjectService.listrealestateobjectchildren(token, realm, val.guid);
            let objects = [];
            if(objsParents?.data && objsParents.data instanceof Array) {
                objects = [...objsParents.data]
            }
            if(objsSiblings?.data && objsSiblings.data instanceof Array) {
                objects = [...objects, ...objsSiblings.data];
            }
            if(objsChildren?.data && objsChildren.data instanceof Array) {
                objects = [...objects, ...objsChildren.data];
            }

            const uniqueIds = [];
            const uniqueObjects = objects.filter(element => {
                const isDuplicate = uniqueIds.includes(element.guid);
                if (!isDuplicate) {
                    uniqueIds.push(element.guid);
                    return true;
                }
                return false;
            });

            uniqueObjects.forEach(item => {
                convert3(item)
            });

            setLiegenschaftSubFlatList(lsfl)
        }
    }

    const setRealestateobjectSubValues = async(val) => {
        setRealestateobjectSubValue(val)
        if(val && val.guid) {
            setNewRealestateobjectGuid(val.guid)
        }
    }

    const setRealestateComponents = async(val) => {
        if(val && val instanceof Array) {
            val.forEach(item => {
                convertComponentList(item)
            });
        }
    }

    function convertComponentList(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.id;
        myItem.guid = item.guid;
        myItem.title = item.name + ' - ' + item.realestateobjectName;
        myItem.key = item.guid;
        componentFlatList.push(myItem);
    }

    const setComponentTypeValue = async(val) => {
        setValue(val);
        if(val) {
            const myTempComponentType = {};
            myTempComponentType.objecttypeId = val.id;
            myTempComponentType.name = val.name;
            myTempComponentType.mmsCode = val.code;
            myTempComponentType.mmsCafmId = val.cafmId;
            myTempComponentType.mmsGlobalId = val.globalId;
            setMyComponentType(myTempComponentType);
            if(userProject && userProject.componenttypes?.length > 0) {
                userProject.componenttypes.forEach(item => {
                    if(item.objecttype_id === val.id) {
                        myAttributList = item.attribute;
                        const myArray = DataComponentService.fillEmptyAttributList(myAttributList)
                        setAttributeList(myArray);

                        const initialFormValues = {
                            name: '',
                            number: '',
                            label: '',
                            description: '',
                            guid: '',
                            id: null,
                            deactivated: 0,
                            position: '',
                            geom: ''
                        }
                        myArray.forEach((item) => {
                            initialFormValues[item.name] = ''
                        });
                        setFormValues(initialFormValues);
                    }
                })
            } else {
                await trackPromise(
                    DataComponentService.getComponentTypeByCode(token, realm, val.code)
                        .then((result) => {
                            myAttributList = result.data[0].attribute;
                            const myArray = DataComponentService.fillEmptyAttributList(myAttributList)
                            setAttributeList(myArray);

                            const initialFormValues = {
                                name: '',
                                number: '',
                                label: '',
                                description: '',
                                guid: '',
                                id: null,
                                deactivated: 0,
                                position: '',
                                geom: ''
                            }
                            myArray.forEach((item) => {
                                initialFormValues[item.name] = ''
                            });
                            setFormValues(initialFormValues);
                        })
                );
            }
        }
    }


    const deactivateClick = async (event) => {
        if (await confirmWrapper('Soll das Bauteil wirklich deaktiviert werden?')) {
            handleDeactivateClick(componentSelected, event);
        }
    }

    const activateClick = (event) => {
        handleActivateClick(componentSelected, event);
    }

    const afterUploadWork = async () => {
        const files = await UploadService.getFiles(componentSelected.id, token, realm, 'component');
        setFileInfos(files.data);
        await reloadComponentList();
    }

    const closeWindow = () => {
        setFormValues(null);
        setDataComponentFormDialogOpen(false);
    }

    return (
        <>
        <Dialog
            className={classesDialog.dialog}
            open={DataComponentFormDialogOpen}
            onClose={() => closeWindow()}
            TransitionComponent={Transition}
            fullScreen
        >
            <Formik
                enableReinitialize
                initialValues={formValues || initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);

                    const objectAttributes = [];
                    let myName = values.name;
                    let myNumber = values.number;
                    let myMark = values.label;
                    let myDescription = values.description;
                    let myPosition = values.position;
                    let myGeom = values.geom;
                    Object.entries(values).map(([key, value]) => {
                        if(key.substring(0, 5) === 'attr_') {
                            const arr = key.split('_');
                            const mmsAttributeId = arr[1];
                            const attr = {};

                            attributeList.map((item) => {
                                if(item.name === key) {
                                    attr.name = item.label;
                                    attr.label = item.label;
                                    attr.attributeType = item.attributeType ? item.attributeType : item.type;
                                    attr.dataType = item.dataType ? item.dataType : item.data_type;
                                    attr.mms_attribut_id = mmsAttributeId;
                                    attr.value = value ? value : "";
                                    objectAttributes.push(attr);
                                }
                            });

                        } else if(key.substring(0, 16) === 'attribute_tenant') {
                            const arr = key.split('_');
                            const attributeId = arr[2];
                            const attr = {}
                            attr.id = attributeId;
                            attr.value = value ? value : "";

                            attributes.forEach((item, index) => {
                                if(item.id.toString() === attributeId.toString()) {
                                    attr.name = item.name;
                                }
                            });
                            objectAttributes.push(attr);
                        }
                    });


                    const data = {
                        name: myName,
                        description: myDescription,
                        guid: values.guid,
                        id: values.id,
                        label: myMark,
                        number: myNumber,
                        position: myPosition,
                        geom: myGeom,
                        realestateobjectGuid: newRealestateobjectGuid,
                        parentComponentGuid: parentComponentValue?.guid,
                        componentType: {
                            objecttypeId: myComponentType?.objecttypeId,
                            name: myComponentType?.name,
                            mmsCode: myComponentType?.mmsCode,
                            mmsCafmId: myComponentType?.mmsCafmId,
                            mmsGlobalId: myComponentType?.mmsGlobalId,
                            guid: myComponentType?.guid
                        }
                    };

                    await saveObject(data, objectAttributes);

                    setSubmitting(false);
                    closeWindow();
                }}
            >
                <Form>
                    <ComponentFormAppBar
                        closeWindow={closeWindow}
                        objectId={componentSelected?.id}
                        />

                    <DataComponentList
                        componentSelected={componentSelected}
                        attributeList={attributeList}
                        treeItemsState={treeItemsState}
                        setComponentTypeValue={setComponentTypeValue}
                        value={value}
                        liegenschaftSubFlatList={liegenschaftSubFlatList}
                        setRealestateobjectSubValues={setRealestateobjectSubValues}
                        realestateobjectSubValue={realestateobjectSubValue}
                        componentFlatListValues={componentFlatListValues}
                        setParentComponentValue={setParentComponentValue}
                        parentComponentValue={parentComponentValue}
                        userProject={userProject}
                    />

                    <DataComponentButtonToolbar
                        componentSelected={componentSelected}
                        deactivateClick={deactivateClick}
                        activateClick={activateClick}
                        setUploadDialogOpen={setUploadDialogOpen}
                        theRealm={realm}
                        />
                   <AttachmentList
                        fileInfos={fileInfos}
                        setFileInfos={setFileInfos}
                        componentSelected={componentSelected}
                        reloadComponentList={reloadComponentList}
                        theRealm={realm}
                    />

                </Form>
            </Formik>

        </Dialog>
    <UploadDialog
        dataObjectSelected={componentSelected}
        setUploadDialogOpen={setUploadDialogOpen}
        uploadDialogOpen={uploadDialogOpen}
        callbackFunc={afterUploadWork}
    />
        </>
    );
}

export default ComponentFormView;
